/* eslint-disable */
const ROOT = '';

const Proxy = '/api';
const sportsProxy = '/sport/';

const HOMEBEFORE = {
  agentCodeCache: ROOT + Proxy + '/guest/agentCodeCache', // 有代理code调用
  init: ROOT + Proxy + "/init", // 获取所有banner列表
  withdrawInit: ROOT + Proxy + "/loged/withdrawInit", // 获取所有banner列表
  BANNERLIST: ROOT + Proxy + "/guest/bannerList", // 获取所有banner列表
  FIRSTNAVLIST: ROOT + Proxy + "/guest/firstNavList", // 获取所有一级导航
  GAMELIST: ROOT + Proxy + "/guest/gameList", // 获取最热游戏列表
  GETGAMEPLATFORM: ROOT + Proxy + "/guest/getGamePlatform", // 获取所有的老虎机游戏平台名称列表
  GETSLOTGAMEPLATFORM: ROOT + Proxy + "/guest/getSlotGameByPlatform", //根据游戏平台代码，获取游戏列表
  INDEXFOOT: ROOT + Proxy + "/guest/indexFoot", // PC端获取页脚信息
  INDEXOFFER: ROOT + Proxy + "/guest/indexOffer", // 获取首页优惠列表
  NAVLISTBYPARENTID: ROOT + Proxy + "/guest/navListByParentId", // 获取非一级导航
  PUSHINFOLIST: ROOT + Proxy + "/guest/pushInfoList", // 根据条件获取需要推送的信息
  serverInfo: ROOT + Proxy + "/guest/serverInfo", // 游客获取服务器信息
  allGameInfo: ROOT + Proxy + "/guest/allGameInfo", // 所有游戏平台
  platformPicInfo: ROOT + Proxy + "/guest/platformPicInfo", // 获取所有平台图片
  floatPicList: ROOT + Proxy + "/guest/floatPicList", // 获取所有挂件
  service: ROOT + Proxy + "/guest/init", // 获取客服链接
  queryIndexOfferList: ROOT + Proxy + "/guest/indexOffer/queryIndexOfferList", // 首页优惠导航
  fetchImgs: ROOT + Proxy + "/guest/fetchImgs", // 根据Code获取配置图片
  fetchImg: ROOT + Proxy + "/guest/fetchImg", // 根据Code获取配置图片
  getGoodVideo: ROOT + Proxy + "/guest/leaderboard/getGoodVedio", // 获取工艺视频
  getCustomizeMatch: ROOT + Proxy + "/guest/getCustomizeMatch", // 获取365体育信息
  // 注册之前或者是否需要用到真实姓名
  queryRealName: ROOT + Proxy + "/guest/queryRegisterItem"
};
const HOMEAFTER = {
  receivePromoteGift: ROOT + Proxy + "/promote/receivePromoteGift", // 领取奖励
  queryPromoteInfo: ROOT + Proxy + "/promote/queryPromoteInfo", // 获取邀请数据
  queryAgentBonus: ROOT + Proxy + "/register/queryAgentBonus", // 获取注册用户是否为代理注册
  DEVIVEINFO: ROOT + Proxy + "/loged/deviceInfo", // 获取用户设备信息
  logedUserInfo: ROOT + Proxy + "/loged/logedUserInfo", // 返回所有登陆后一级页面需要的用户信息
  refreshUserInfo: ROOT + Proxy + "/loged/refreshUserInfo", // PC端首页顶部刷新按钮
  refresh: ROOT + Proxy + "/loged/refresh", // 检测登录状态
  queryUserLockAmount: ROOT + Proxy + "/loged/queryUserLockAmount", // 查询会员账户锁定金额记录
  selfUnlockAmount: ROOT + Proxy + "/loged/selfUnlockAmount", // 会员自助解锁锁定金额
  getminLimit: ROOT + Proxy + "/loged/withdrawInit", // 最低取款额
  getfrontconfig: ROOT + Proxy + "/guest/frontConfig/getFrontConfig", // 365代理联系方式
  getFrontConfigList: ROOT + Proxy + "/guest/frontConfig/getFrontConfig/list" // 365所有代理联系方式
};
const USER = {
  REGISTER: ROOT + Proxy + "/guest/registered", // 注册
  registeredNew: ROOT + Proxy + "/guest/registeredNew", // (多彩宝)注册
  REGISTERCODE: ROOT + Proxy + "/guest/defaultKaptcha", // 验证码
  captcha: ROOT + Proxy + "/guest/captcha", // 验证码
  LOGIN: ROOT + Proxy + "/login", // 登陆
  FIRSTUSERINFO: ROOT + Proxy + "/loged/firstUserInfo", // 首次登陆信息
  LOGINOUT: ROOT + Proxy + "/loged/logout", // 登出
  MYCOLLECTION: ROOT + Proxy + "/loged/myCollection", // 我的收藏
  LASTSCAN: ROOT + Proxy + "/loged/lastScan", // 最近浏览过的游戏
  updateLoginPassword: ROOT + Proxy + "/loged/updateLoginPassword", // 更改登陆密码
  confirm: ROOT + Proxy + "/guest/forget/confirm", // 忘记密码功能：第二步，输入账号、手机/邮箱，加类型，验证码，密码，确认密码
  sendCode: ROOT + Proxy + "/guest/forget/sendCode", // 忘记密码功能：第一步，输入账号、手机/邮箱，加类型，发送验证码
  sendCodeNew: ROOT + Proxy + "/guest/forget/sendCodeNew", // (多彩宝) 忘记密码功能：第一步，输入账号、手机/邮箱，加类型，发送验证码
  forgetPassword: ROOT + Proxy + "/guest/forgetPassword", // 忘记密码功能：请预留正确的联系方式客服会在1天内主动联系，或者直接联系客服
  depositList: ROOT + Proxy + '/logged/depositList', // 获取所有存款申请
  sendVerifictionCode:
    ROOT + Proxy + "/guest/lottery/login/sendVerifictionCode", //手机验证码登录
  JUMPAGENTLOGIN: ROOT + Proxy + "/promote/jumpAgentLogin" // 新增接口，跳转代理中心，
};

const GAME = {
  gamePlatform: ROOT +  Proxy + '/game/guest/gamePlatform',  // 获取游戏类型列表
  heatGamePlatform: ROOT + Proxy + '/game/guest/heatGamePlatform', //获取热门
  topFlowData: ROOT +  Proxy + '/logged/topFlowData',  // 获取今日流水
  searchResult: ROOT +  Proxy + '/guest/searchResult',  // 搜索

  allGame: ROOT +  Proxy + '/game/guest/allGame',  // 平台全部游戏（棋牌等..）
  newGame: ROOT +  Proxy + '/game/guest/newGame',  // 平台最新游戏（棋牌等..）
  hotGame: ROOT +  Proxy + '/game/guest/hotGame',  // 平台热门游戏（棋牌等..）
  queryAllGameList:  ROOT +  Proxy + '/game/guest/queryAllGameList',  //牛牛


};

// slot-controller 老虎机的首页接口
const SLOT = {
  slotBanner: ROOT +  Proxy + '/guest/slotBanner',// 老虎机banner
  slotOffer: ROOT +  Proxy + '/guest/slotOffer',// 老虎机相关优惠
  slotRank: ROOT +  Proxy + '/guest/slotRank',// 老虎机压码排行
  totalSlot: ROOT +  Proxy + '/guest/totalSlot',// 老虎机全部游戏
  maybeLike: ROOT +  Proxy + '/logged/maybeLike',// 可能喜欢
  mySlot: ROOT +  Proxy + '/logged/mySlot',// 我的游戏列表
  addCollection: ROOT +  Proxy + '/logged/addCollection',// 添加游戏至我的收藏
  cancelCollection: ROOT +  Proxy + '/logged/cancelCollection',// 取消收藏

  selectGameSlotType: ROOT +  Proxy + '/guest/selectGameSlotType',// 老虎机游戏
};
const VIP = {
  VIPPRIVILEGE: ROOT +  Proxy + '/guest/vipPrivilege', // VIP特权
  CHECKIN: ROOT +  Proxy + '/loged/checkin', // 签到
  CHECKININFO: ROOT +  Proxy + '/loged/checkinInfo', // 签到的信息
  LOTTERY: ROOT +  Proxy + '/loged/lottery', // 签到抽奖
  inviteCode: ROOT +  Proxy + '/loged/inviteCode', // 生成邀请码
  inviteList: ROOT +  Proxy + '/loged/inviteList', // 生成邀请列表
  getInviteBonus: ROOT +  Proxy + '/loged/getInviteBonus', // 点击领取奖金按钮，领取奖金
  myBalanceList: ROOT +  Proxy + '/loged/myBalanceList', // 我的账单列表
  balanceDetail: ROOT +  Proxy + '/loged/balanceDetail', // 账单详情
  getMsgSiteList: ROOT +  Proxy + '/loged/getMsgSiteList', // 站内信
  updateMsgSite: ROOT +  Proxy + '/loged/updateMsgSite', // 站内信状态
  deleteMsgSite: ROOT +  Proxy+ '/loged/deleteMsgSite', //删除站内信
  insertMsgSite: ROOT +  Proxy+ '/loged/insertMsgSite', //会员发送信息
};

const DISCOUNTS={
  OFFERBANNER: ROOT +  Proxy + '/guest/offerBanner', // 优惠板块的banner
  OFFERLIST: ROOT +  Proxy + '/guest/offerList', // 根据条件筛选
  OFFERTYPELIST: ROOT +  Proxy + '/guest/offerTypeList', // 获取优惠类型
  MYOFFER: ROOT +  Proxy + '/loged/myOffer', // 获取我的优惠列表
  queryBonusArticleTypeList:ROOT +  Proxy + '/guest/queryBonusArticleTypeList', // （新）获取优惠类型
  queryBonusArticleInfoList:ROOT +  Proxy + '/guest/queryBonusArticleInfoList', // （新）获取优惠列表
  querySelfApplyBonusList:ROOT +  Proxy + '/guest/querySelfApplyBonusList' , //活动大厅列表
  queryBonusArticleInfoDetail:ROOT +  Proxy + '/guest/queryBonusArticleInfoDetail',//活动大厅获取文章
  offerDetail: ROOT +  Proxy + '/guest/offerDetail', // 进入优惠详情
  relatedOffer: ROOT +  Proxy + '/guest/relatedOffer', // 获取游戏的相关优惠
  getrankList: ROOT + Proxy + '/guest/leaderboard/query',  //获取排行榜数据
  getrefresh: ROOT + Proxy + '/guest/leaderboard/refresh'  //获取排行榜数据
};
// money
const WALLET = {
  RECHARGE:ROOT +  Proxy + '/indexpay/webpay_gateway',
  withdrawList:ROOT +  Proxy + '/logged/withdrawList',
  refreshGameAccount:ROOT +  Proxy + '/loged/withdrawGames', // 账户刷新
  balance:ROOT +  Proxy + '/game/balance', //  获取平台余额
  gameHistory:ROOT +  Proxy + '/game/logged/gameHistory', //  获取投注记录
  newgameHistory:ROOT +  Proxy + '/game/logged/newGameHistory',
};

// 支付方式
const PAY = {
  queryUsdtAddress: ROOT + Proxy + "/indexpay/queryUsdtAddress", // 获取充值渠道钱包信息
  getUsdtWalletInfo: ROOT + Proxy + "/logged/getUsdtWalletInfo", // 获取充值渠道钱包信息
  newlyWithdrawAccount: ROOT + Proxy + "/loged/newlyWithdrawAccount",
  apppay_usdt: ROOT + Proxy + "/indexpay/apppay_usdt",
  apppay_vippay: ROOT + Proxy + "/indexpay/apppay_vippay",
  getUSDTAddress: ROOT + Proxy + "/loged/getUSDTAddress",
  applyWithdrawUSDT: ROOT + Proxy + "/loged/applyWithdrawUSDT",
  applyWithdrawJdPay: ROOT + Proxy + "/loged/applyWithdrawJDPay",//新增钱包添加
  applyWithdrawEbPay: ROOT + Proxy + "/loged/applyWithdrawEbPay",
  applyWithdrawGoPay: ROOT + Proxy + "/loged/applyWithdrawGoPay",
  applyWithdrawKdPay: ROOT + Proxy + "/loged/applyWithdrawKdPay",
  applyWithdrawCbPay: ROOT + Proxy + "/loged/applyWithdrawCbPay",
  applyWithdrawOkPay: ROOT + Proxy + "/loged/applyWithdrawOkPay",
  //vipPay相关接口
  covertVipWallet: ROOT + Proxy + "/loged/covertVipWallet",
  applyWithdrawVipPay: ROOT + Proxy + "/loged/applyWithdrawVipPay",
  payorder: ROOT + Proxy + "/usdtpay/payorder", //usdt充值
  queryUsdtChain: ROOT + Proxy + "/indexpay/queryUsdtChain",
  withdrawRate: ROOT + Proxy + "/loged/withdrawRate",
  addBankCard: ROOT + Proxy + "/loged/addBankCard", // 添加银行卡
  deleteBank: ROOT + Proxy + "/loged/deleteBank", // 删除银行卡
  bankCardList: ROOT + Proxy + "/loged/bankCardList", // 获取银行卡列表
  checkBankCard: ROOT + Proxy + "/loged/checkBankCard", // 验证银行卡信息
  payType: ROOT + Proxy + "/loged/payType", // 获取支付类型
  newPayType: ROOT + Proxy + "/loged/payType/v2", // 获取新支付类型
  payConfig: ROOT + Proxy + "/loged/payConfig/v2", // 获取支付的内容
  sendWithdrawYZM: ROOT + Proxy + "/loged/sendWithdrawYZM", // 发送提款密码验证码 / 修改邮箱验证码
  setWithdrawPW: ROOT + Proxy + "/loged/setWithdrawPW", // 设置提款密码
  updateWithdrawPW: ROOT + Proxy + "/loged/updateWithdrawPW", // 修改提款密码
  applyWithdraw: ROOT + Proxy + "/loged/applyWithdraw", // 申请提现
  deposit: ROOT + Proxy + "/loged/deposit", // 向游戏平台转账
  withdraw: ROOT + Proxy + "/loged/withdraw", // 向中心钱包转账
  getAllPlatform: ROOT + Proxy + "/loged/getAllPlatform", // 获取所有平台
  withdrawGames: ROOT + Proxy + "/loged/withdrawGames", // 取出全部的金额，用于提现等页面
  withdrawConfirm: ROOT + Proxy + "/loged/withdrawConfirm", // c2c提款確認

  getUserApAccount: ROOT + Proxy + "/logged/getUserApAccount", // 获取会员绑定的支付宝
  addAlipayAccount: ROOT + Proxy + "/logged/addAlipayAccount", // 绑定支付宝账号
  addUSDTAccount: ROOT + Proxy + "/logged/addUSDTAccount", // 绑定USDT支付
  addUSDT: ROOT + Proxy + "/loged/addUSDT", // 绑定USDT支付
  usdtLinkTypeList: ROOT + Proxy + "/logged/usdtLinkTypeList", // 获取USDT系统供应链类型
  selectUserAllUSDTList: ROOT + Proxy + "/logged/selectUserAllUSDTList", // 获取会员所有USDT列表
  deleteUSDT: ROOT + Proxy + "/loged/deleteUSDT",
  setDefaultUSDT: ROOT + Proxy + "/loged/setDefaultUSDT",
  userDeleteUSDT: ROOT + Proxy + "/logged/userDeleteUSDT", // 会员删除USDT钱包
  userOperateUSDTConsent: ROOT + Proxy + "/logged/userOperateUSDTConsent", // 设置默认USDT钱包
  getUsdtRate: ROOT + Proxy + "/indexpay/getUsdtPrice", //获取链名称对应的汇率
  newUSDTList: ROOT + Proxy + "/loged/newUSDTList",
  gainWithdrawAccount: ROOT + Proxy + "/loged/gainWithdrawAccount",
  getLimit: ROOT + Proxy + "/loged/queryLimitByType", // 获取类型下的对应汇率
  getFeeSetting: ROOT + Proxy + "/loged/withdrawFeeSettingList" //获取提现费率
};
// 帮助/关于我们板块接口
const HELP = {
  articleById:ROOT +  Proxy + '/guest/articleById', // 根据文章id获取文章
  articleListByType:ROOT +  Proxy + '/guest/articleListByType', // 根据文章类型获取文章列表
  articleType:ROOT +  Proxy + '/guest/articleType', // 获取文章类型
  pushInfo:ROOT +  Proxy + '/guest/pushInfo', // 获取当前时间的推送通知-未登陆状态
  logedPushInfo:ROOT +  Proxy + '/loged/pushInfo', // 获取所有推送和通知-已登陆状态
};

// 认证
const CONFIRM ={
  confirmEmail:ROOT +  Proxy + '/loged/confirmEmail', // 邮箱认证
  submitEmail:ROOT +  Proxy + '/loged/submitEmail ', // 邮箱认证 只需要提交邮箱
  confirmPhone:ROOT +  Proxy + '/loged/confirmPhone', // 手机验证
  confirmRealName:ROOT +  Proxy + '/loged/confirmRealName', // 实名认证接口
  email:ROOT +  Proxy + '/loged/email', // 发送邮箱验证
  sendPhone:ROOT +  Proxy + '/loged/sendPhone', // 发送手机验证码
  phoneCodeVerification:ROOT +  Proxy + '/logged/phoneCodeVerification', // 验证手机
  sendCodeForPhone:ROOT +  Proxy + '/logged/sendCodeForPhone', // 共用方法，给当前登陆用户发送手机验证码
  updateEmail:ROOT +  Proxy + '/loged/updateEmail', // 修改邮箱

  queryCountryList:ROOT +  Proxy + '/guest/search/queryCountryList', // 获取电话国家列表
  sendPhoneSMS:ROOT +  Proxy + '/loged/sendPhoneSMS', // 发送验证码


  confirmQQ:ROOT +  Proxy + '/loged/confirmQQ', // 发送验证码
  confirmWeChat:ROOT +  Proxy + '/loged/confirmWeChat'  // 发送验证码
};
// 红利
const DEPOSIT ={
  showIndexInfo:ROOT +  Proxy + '/deposit/showIndexInfo', // 首页展示信息 - 存款红利
  showPrizeInfo:ROOT +  Proxy + '/deposit/showPrizeInfo', // 进入抽奖页面，获取奖品展示的接口，如果没有那么展示静态奖品
  clickButton:ROOT +  Proxy + '/deposit/clickButton', // 点击抽奖按钮
  applyBonus:ROOT +  Proxy + '/deposit/applyBonus', // 申请存款红利
  otherApplyBonus:ROOT +  Proxy + '/other/applyBonus', // 申请其他红利

  getRealTimeAmount:ROOT +  Proxy + '/guest/getRealTimeAmount', // 领取时时流水
  realTimeAmount:ROOT +  Proxy + '/guest/realTimeAmount', // 查看时时流水
  queryBonusBindUserInfoList:ROOT +  Proxy + '/guest/queryBonusBindUserInfoList', // 查询会员绑定优惠

  receiveMyBonus:ROOT +  Proxy + '/loged/receiveMyBonus', // 红利领取中心领取红利

  selectUserUpgradeInfo:ROOT +  Proxy + '/deposit/selectUserUpgradeInfo', // 查询会员绑定优惠

  queryTurntableRaffle:ROOT +  Proxy + '/activity/guest/queryRaffle', // 大转盘抽奖 未登录
  raffle:ROOT +  Proxy + '/activity/raffle', // 大转盘抽奖 已登录
  queryHistoryWin:ROOT +  Proxy + '/activity/queryHistoryWin', // 大转轮历史记录
  wheelActivityRealWin:ROOT +  Proxy + '/activity/guest/queryNewWin', // 大转轮中奖真实数据

  // 签到活动
  signInActivityBonusInfo:ROOT +  Proxy + '/loged/selectSignInBonus', // 获取签到优惠信息
  updateSignInSchedule:ROOT +  Proxy + '/loged/updateSignInSchedule', // 获取签到更新信息
  getSignInPrizeInfo:ROOT +  Proxy + '/loged/completeSignInSchedule', // 获取签到奖励
  getOtherPrizeInfo:ROOT +  Proxy + '/loged/receiveSignInOtherBonus', // 获取额外奖励
  exchangeScoreInfo:ROOT +  Proxy + '/loged/exchangePointBonus', // 积分兑换

  // 余额宝
  availableYEBList:ROOT +  Proxy + '/applyBonus/selectBonusBalanceProfitList', // 查询可购买的余额宝列表
  purchasedYEBList:ROOT +  Proxy + '/applyBonus/queryUserBuyBalanceProfitList', // 查询已购买的余额宝列表
  buyYEBProgram:ROOT +  Proxy + '/applyBonus/buyBalanceProfit', // 购买余额宝
  ransomYEBProgram:ROOT +  Proxy + '/applyBonus/ransomBalanceProfit', // 赎回余额宝
};
// 问卷
const QUESTION={
  totalQuestionnaire:ROOT +  Proxy + '/guest/questionnaire/getTotalQuestionnaire', // 获取当前启动的调查问卷
   submitQuestionnaireIri:ROOT +  Proxy + '/guest/questionnaire/submitQuestionnaire', // 提交当前启动的调查问卷
   getAwardIri:ROOT +  Proxy + '/guest/questionnaire/getQuestionnaireReward', // 提交当前启动的调查问卷
};

// 体育
const SPORT = {
  sport: ROOT +  sportsProxy  // 首页数据
}
/**
 * 威尼斯 */
const agency_register = ''  //代理注册：
const agency_login = ''  //代理登入：

// 代理网址
const agentUrl = '';
// 线路网址
const loadUrl = '';
// 下载地址
const downloadPC = '';
// 客服
const service = '';

/**
 * 多彩宝 */
// 代理网址
// const color_Agent_Url = 'https://affiliate.docobo88.com/#agent/register';
const color_Agent_Url = '';


/**
 * 金色版 */
const gold_Agent_Url = '';
const gold_service_Url = '';
const gold_app_download = '';

/**
 * 太阳城
 * */
const sun_loadUrl = '';
const sun_service = '';
const sun_agentUrl = '';

/**
 *  build07
 * */
const sands2_loadUrl = '';
const sands2_downloadPC = '';
const sands2_service = '';
const sands2_agentUrl = '';

/**
 * 金沙新 9750*/
const newSands_agentUrl = '';
const newSands_agentUrl_login = '';


/**
 * 威尼斯 2668*/


/**
 * 365 */


/**
 * 乐赢 */
const ly_agentUrl = ''
const ly_registerAgentUrl = ''
const ly_detectionUrl = ''

export default {
  HOMEBEFORE: HOMEBEFORE,
  HOMEAFTER: HOMEAFTER,
  DISCOUNTS: DISCOUNTS,
  USER: USER,
  SLOT: SLOT,
  WALLET: WALLET,
  VIP,
  PAY,
  HELP,
  CONFIRM,
  GAME,
  DEPOSIT,
  QUESTION,
  SPORT,
  color_Agent_Url,

  agency_register,
  agency_login,
  service,
  downloadPC,
  agentUrl,
  loadUrl,
  sun_loadUrl,
  sun_service,
  sun_agentUrl,

  gold_service_Url,
  gold_app_download,
  gold_Agent_Url,

  sands2_loadUrl,
  sands2_service,
  sands2_agentUrl,
  sands2_downloadPC,

  newSands_agentUrl,
  newSands_agentUrl_login,

  // loadUrl_2668,
  // agentUrl_2668,

  // agentUrl_365,
  // hijack_365,

  ly_agentUrl,
  ly_registerAgentUrl,
  ly_detectionUrl
}



// WEBPACK FOOTER //
// ./src/common/urls/url.js